import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { EmailAddressesReducer } from "../reducers/EmailAddressesReducer";

const EmailAddressesContext = createContext({
	state: EmailAddressesReducer.getInitialState(),
	actions: EmailAddressesReducer.actions,
});

export const useEmailAddressesContext = () => useContext(EmailAddressesContext);

export const EmailAddressesProvider = ({
	children,
}: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: EmailAddressesReducer.getInitialState(),
		reducers: EmailAddressesReducer.caseReducers,
	});

	return (
		<EmailAddressesContext.Provider value={{ state, actions }}>
			{children}
		</EmailAddressesContext.Provider>
	);
};
